export const gameName = 'dreamwheel';
export const socketGamePath = 'game';

export const appMode = process.env.REACT_APP_MODE;
